
<sm-title-bar [headerCustomTemplate]="addButton" pageTitle="{{ 'customers.title' | translate }}" [backWithParams]="true">
    <ng-template #addButton>
      <div class="booking_sectionkl">
        <div class="Create_header_btn">
          <button mat-icon-button color="primary" (click)="addmember()"> <mat-icon>add</mat-icon></button>
       </div>
       <!-- <div class="Create_header_btn">
        <button mat-flat-button color="primary" (click)="createInvoice()"> <mat-icon>add</mat-icon> Bill / Invoice</button>
       </div> -->
      </div>
    </ng-template>
  </sm-title-bar>


  <div class="chip_cont">
    <mat-chip-listbox aria-label="Fish selection" class="mb-1">
      <mat-chip
        style="
        margin-right: 12px;
        margin-bottom: 0px !important;
        margin-top: 0px !important;"
        [ngClass]="{ selected: selectedValue == '0' }"
        (click)="changeChip('0')"
        >{{ 'customers.tab_1' | translate }}
      </mat-chip>
    </mat-chip-listbox>
  
    <mat-chip-listbox aria-label="Fish selection" class="mb-1">
      <mat-chip
       
        [ngClass]="{ selected: selectedValue == '1' }"
        (click)="changeChip('1')"
        >{{ 'customers.tab_2' | translate }}
      </mat-chip>
    </mat-chip-listbox>
    <mat-chip-listbox aria-label="Fish selection" class="mb-1">
      <mat-chip
        
        [ngClass]="{ selected: selectedValue == '2' }"
        (click)="changeChip('2')"
        >{{ 'customers.tab_3' | translate }}
      </mat-chip>
    </mat-chip-listbox>
  </div>
  <div style="margin-bottom: 10px;" *ngIf="!loader">
    <div class="search-field" >
      <mat-form-field appearance="outline" class="me-2">
        <mat-label>{{ 'customers.search_label' | translate }}</mat-label>
        <input
        [formControl]="searchString"
         
          matInput
          placeholder="{{ 'customers.search_placeholder' | translate }}"
          (keyup)="searchServiceData()"
        />
        <button
          mat-button
          *ngIf="!searchString.value"
          matSuffix
          aria-label="Clear"
        >
          <mat-icon>search</mat-icon>
        </button>
        <button
        mat-button
        *ngIf="searchString.value"
        matSuffix
        aria-label="Clear"
        (click)="reset()"
      >
        <mat-icon>close</mat-icon>
      </button>
      </mat-form-field>

      
    </div>
       <!-- <sm-title-bar pageSubTitle="Services" [showBackButton]="true"></sm-title-bar> -->
    <!-- <div class="rounded-3 bg-light" *ngIf="!loader && customersData.length > 0">
      <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="customersData" [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate"
         [showPagination]="true" [showImageColumn]="true"  [imageTemplate]="image" [itemsPerPage]="25">
      </sm-data-table>
    </div> -->
  </div>


  <div class="customer_card" *ngIf="!loader && customersData.length > 0">
    <div class="row">
      <div class="col-sm-6 col-md-6 col-12" *ngFor="let item of customersData">
    <mat-card >
    <div class="package-card" >
      <div class="package-header">
        <div class="profile-container">
          <div class="booking-initial" *ngIf="!item.image_thumb_url || item.image_thumb_url == 'null'">{{item.name.slice(0,1).toUpperCase()}}</div>
          <div class="profile-image booking-initial-img" *ngIf="item.image_thumb_url && item.image_thumb_url != 'null'">
            <!-- <span class="initials" *ngIf="!item.image_thumb_url || item.image_thumb_url == 'null'">N</span> -->
            <img class="img-fluid rounded-circle" [src]="item.image_thumb_url" alt=""  onerror="this.src='../../../../assets/images/user-avatar.svg'">
          </div>

          <div class="profile_texc">
          <h2 class="package-title">{{item.name}}</h2>
          <p class="package-detail">{{item.cust_phone}}{{item.gender1 && item.gender1 != '---' ? ', ' + item.gender1 : ''}}</p>
        </div>

        </div>
    
        

        <button mat-icon-button [matMenuTriggerFor]="menu" class="package-options" >
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="viewdetailsopen(item)">
            <mat-icon class="material-icons-outlined">info</mat-icon>
            <span>View details</span>
          </button>
          <button mat-menu-item (click)="createInvoice(item)" *ngIf="isAccessForEmployeeInvoice">
            <mat-icon class="material-icons-outlined">playlist_add</mat-icon>
            <span>Create invoice</span>
          </button>
          <!-- <button mat-menu-item (click)="openAllBookings(item)">
            <mat-icon>list</mat-icon>
            <span>{{ 'customers.op1' | translate }}</span>
          </button>
          <button mat-menu-item (click)="openAllPayments(item)">
            <mat-icon class="material-icons-outlined">receipt</mat-icon>
            <span>See all payments</span>
          </button> -->
          <button mat-menu-item (click)="openDueBookings(item)">
            <mat-icon class="material-icons-outlined">pending_actions</mat-icon>
            <span>See due bills/invoices</span>
          </button>
       
          <button mat-menu-item (click)="openPaymentIntimation(item)" *ngIf="item.total_due > 0 && isOwner">
            <mat-icon class="material-icons-outlined">share</mat-icon>
            <span>{{ 'customers.op3' | translate }}</span>
          </button>
          <!-- <button mat-menu-item (click)="deleteCustomer(item)" >
            <mat-icon class="material-icons-outlined">delete</mat-icon>
            <span>Delete Customer</span>
          </button> -->
        </mat-menu>
        
      </div>
      
    
      <p class="package-highlight"><span class="deo_heading">Due:</span>  <span class="cureent_ht">{{item.currency_symbol}}{{item.total_due.toFixed(2)}}</span></p>
      <p class="package-date"><span class="deo_heading">Last booking: </span> <span class="cureent_ht">{{item.l_booking_date}}</span></p>
    </div>
  </mat-card>
    </div>
    </div>
  </div>



  
  
  <ng-template #menuTemplate let-rowvalue>
    <button mat-menu-item (click)="viewdetailsopen(rowvalue)">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>View details</span>
    </button>
    <button mat-menu-item (click)="createInvoice(rowvalue)">
      <mat-icon class="material-icons-outlined">receipt_long</mat-icon>
      <span>Create invoice</span>
    </button>
    <button mat-menu-item (click)="openAllBookings(rowvalue)">
      <mat-icon class="material-icons-outlined">receipt_long</mat-icon>
      <span>{{ 'customers.op1' | translate }}</span>
    </button>
    <button mat-menu-item (click)="openAllPayments(rowvalue)">
      <mat-icon class="material-icons-outlined">receipt_long</mat-icon>
      <span>See all payments</span>
    </button>
    <button mat-menu-item (click)="openDueBookings(rowvalue)">
      <mat-icon class="material-icons-outlined">pending_actions</mat-icon>
      <span>See due bills/invoices</span>
    </button>
 
    <button mat-menu-item (click)="openPaymentIntimation(rowvalue)" *ngIf="rowvalue.total_due > 0">
      <mat-icon class="material-icons-outlined">mail</mat-icon>
      <span>{{ 'customers.op3' | translate }}</span>
    </button>
    <button mat-menu-item (click)="deleteCustomer(rowvalue)" >
      <mat-icon class="material-icons-outlined">delete</mat-icon>
      <span>Delete Customer</span>
    </button>
    <!-- <button mat-menu-item (click)="customerviewdetails()">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>View details</span>
    </button> -->
  </ng-template>
  
  <ng-template #image let-objValue>
    <img
      [src]="
        objValue['image_thumb_url'] !== null && objValue['image_thumb_url'] !== 'null' && objValue['image_thumb_url'] !== ''
          ? objValue['image_thumb_url']
          : './assets/images/photo.png'
      "
      class="img-fluid rounded-circle"
    />
  </ng-template>
  <!-- <mat-paginator
  *ngIf="!loader"
    class="mt-4"
    [length]="datalength"
    [pageSize]="25"
    (page)="onPageChange($event)"
  >
  </mat-paginator> -->
  
    <!-- placeholder html start -->
    <div class="placeholder_started" *ngIf="!loader && customersData.length == 0">
      <div class="row">
        <div class="col-sm-4" *ngIf="selectedValue == '0'">
          <div class="dashboard_new">
            <mat-card appearance="outlined">
                <div class="upload_sectio">
               <div class="icm_img">
                  <img src="./assets/images/customer-1.jpg">
               </div>
               <mat-card-title>No customer to show.</mat-card-title>
               <mat-card-content>Creating booking and invoice adds customers automatically to your business. You can add customers manually too.
              </mat-card-content>
               <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary" (click)="addmember()">
                     <mat-icon>add</mat-icon>
                     Add customer
                  </button>
               </div>
               </div>
            </mat-card>
         </div>
        </div>
        <div class="col-sm-4" *ngIf="selectedValue == '1'">
          <div class="dashboard_new">
            <mat-card appearance="outlined">
                <div class="upload_sectio">
               <div class="icm_img">
                  <img src="./assets/images/customer-1.jpg">
               </div>
               <mat-card-title>No customer with dues.</mat-card-title>
               <mat-card-content>The customers with unpaid invoices and dues in payments, will show here. Apart from the due data and other information, you can send them payment intimation too.
              </mat-card-content>
               <!-- <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary">
                     <mat-icon>add</mat-icon>
                     Add customer
                  </button>
               </div> -->
               </div>
            </mat-card>
         </div>
        </div>
        <div class="col-sm-4" *ngIf="selectedValue == '2'">
          <div class="dashboard_new">
            <mat-card appearance="outlined">
                <div class="upload_sectio">
               <div class="icm_img">
                  <img src="./assets/images/customer-1.jpg">
               </div>
               <mat-card-title>No long absent customer yet.</mat-card-title>
               <mat-card-content>The customers who haven't visited the business for long, will appear here. You can get their details, contact them, send them personalized message with offers.
              </mat-card-content>
               <!-- <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary">
                     <mat-icon>add</mat-icon>
                     Add customer
                  </button>
               </div> -->
               </div>
            </mat-card>
         </div>
        </div>
        <div class="col-sm-4">
          <div class="dashboard_new">
            <mat-card appearance="outlined">
                <div class="upload_sectio">
               <div class="icm_img">
                  <img src="./assets/images/helpsupport.png">
               </div>
               <mat-card-title>Facing any issue?</mat-card-title>
               <mat-card-content>For any difficulties in creating a new customer or if there's any issue with customer data, contact the support team.
              </mat-card-content>
               <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary"  (click)="opencontact()">
                     <mat-icon>support_agent</mat-icon>
                     Contact support 
                  </button>
               </div>
               </div>
            </mat-card>
         </div>
        </div>
      </div>
</div> 
<!-- placeholder html end -->